import {Observable} from "rxjs";
import * as QRCode from "qrcode";

export const createQR = (url: string): Observable<string> => {
  return new Observable(obs => {
    const canvas = document.createElement('canvas')
    QRCode.toCanvas(canvas, url, function (error) {
      if (error) console.error(error)
      obs.next(canvas.toDataURL());
      obs.complete();
    })
  })
}

